import styled from 'styled-components';
import { palette, spacing } from '@mui/system';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "styled-components": styled, "@mui/system": { palette, spacing } } } });
export default ClientProvider;
